// extracted by mini-css-extract-plugin
export default {"Timer":"components-Timer-_Timer-module_Timer","timer":"components-Timer-_Timer-module_Timer","inline":"components-Timer-_Timer-module_inline"};